module.exports = __webpack_public_path__ + "static/media/bg-pic2.ea655fbf.jpg";